// extracted by mini-css-extract-plugin
module.exports = {"card2":"_33dGOKAW4G58jj3ziBl3N_","card3":"_36Lel4p_v-r8WnZXW8xhXB"};